import React,{useState,useEffect} from 'react'
import {useParams} from 'react-router-dom'
import BlogGeneralCard from "./BlogGeneralCard";
import "./BlogTrendingContainer.css";
import BlogNavbar from './BlogNavbar';
import Footer from '../Footer/footer';
import GetAPI from "../APICalls/GetAPI";

const SingleCategories = () => {
  const {title}=useParams()
  
  const [data,setData]=useState([])
  const getBlogs=()=>{

    let environment = process.env.REACT_APP_NODE_ENV;
    let getSingleBlogApi;
        if (environment === "PRODUCTION" || environment === undefined) {
          getSingleBlogApi = process.env.REACT_APP_PROD_BLOGAPI;
        } else {
          getSingleBlogApi = process.env.REACT_APP_DEV_BLOGAPI;
        }
        
    GetAPI(`${getSingleBlogApi}?type=category&category=${title}`)
    .then((res)=>{
      console.log(res)
      if (res.data.statusCode === 200) {
        console.log("category",res.data)
        setData(res.data.body);
    }
  })
    .catch(err=>{
      console.log(err)
    })

  }
useEffect(()=>{
  getBlogs()
  window.scrollTo(0,0);
},[])

console.log(data)
  return (
    <>
     <BlogNavbar />
    <div className="single-category-container">
      <div className="trending-container-heading">
      <span>Trending {title} Stories </span>
      <div className="trending-container-heading-line"></div>
      </div>
      <div className="trending-container">
        {data.map((data,index)=>{
            return(
              <BlogGeneralCard data={data} index={index} />
            )
        })}
    </div>
    </div>
    <Footer />
    </>
  )
}

export default SingleCategories